import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Typography } from '../Typography';
import './GoBack.scss';

interface GoBackProps {
  className?: string;
}

const GoBack: React.FC<GoBackProps> = ({ className }) => {
  const navigate = useNavigate();
    const { t } = useTranslation('common');

  return (
    <div
      className={`go-back__container ${className ?? ''}`}
      onClick={() => navigate(-1)}
      style={{ cursor: 'pointer' }}
    >
      <Typography
        className="go-back__text"
        color="color-26"
        variant="size-14"
        weight="bold"
      >
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: 8 }} />
        {t('buttons.goBack')}
      </Typography>
    </div>
  );
};

export default GoBack;
